import React from "react";
import "../assets/styles/Project.scss";
import HotstarCloneImage from "../assets/images/hotstar-clone.png"
import SequelizeNpmImage from "../assets/images/sequlize-npm.png"
import LittleLemonImage from "../assets/images/little-lemon.png"
import MetaNewsImage from "../assets/images/Meta News.webp"
import OnlineVaccineImage from "../assets/images/online-vaccine.webp"
import FoodDeliveryImage from "../assets/images/food-delivery.png"
import CloudNotesImage from "../assets/images/cloud-notes.webp"
import TextUtilityImage from "../assets/images/textutils.webp"
import JsCalcyImage from "../assets/images/js_calcy.png"
import AbhinavCollegeImage from "../assets/images/abhi-college.webp"
import GymImage from "../assets/images/gym_website.png"
import PortfolioImage from "../assets/images/portfolio.png"
import ElevateGymImage from "../assets/images/elevate_gym.jpg"

function Project() {
    return (
        <div className="projects-container" id="projects">
            <h1>Personal Projects</h1>
            <div className="projects-grid">
                <div className="project">
                    <a href="https://elevate-gym.onrender.com/" target="_blank" rel="noreferrer">
                        <img src={ElevateGymImage} className="zoom" alt="Elevate Gym Thumbnail" width="100%" />
                        <h2>Elevate Gym</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/ELEVATE-GYM" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Developed a modern and responsive website for a gym, showcasing services and facilities.</p>
                </div>
                <div className="project">
                    <a href="https://disneyplus-hotstar-site-clone.netlify.app/" target="_blank" rel="noreferrer">
                        <img src={HotstarCloneImage} className="zoom" alt="Disney+ Hotstar Clone Thumbnail" width="100%" />
                        <h2>Disney+ Hotstar Clone</h2>
                    </a>

                    <a href="https://github.com/shubhamy4ever/disney-hostar_clone" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Built a responsive clone of the Disney+ Hotstar platform with advanced React features and modern UI components.</p>
                </div>
                <div className="project">
                    <a href="https://www.npmjs.com/package/sequelize-migration-builder" target="_blank" rel="noreferrer">
                        <img src={SequelizeNpmImage} className="zoom" alt="Sequelize Migration Builder Thumbnail" width="100%" />
                        <h2>Sequelize Migration Builder</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/sequelize-migration-builder" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Published an npm package to streamline the generation and management of Sequelize migrations.</p>
                </div>
                <div className="project">
                    <a href="https://sprightly-raindrop-287b2b.netlify.app/" target="_blank" rel="noreferrer">
                        <img src={LittleLemonImage} className="zoom" alt="Little Lemon Project Thumbnail" width="100%" />
                        <h2>Little Lemon Project</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/little-lemon-project" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Developed a restaurant landing page using the ReactJS.</p>
                </div>
                <div className="project">
                    <a href="https://shubhamy.netlify.app/" target="_blank" rel="noreferrer">
                        <img src={PortfolioImage} className="zoom" alt="Portfolio Thumbnail" width="100%" />
                        <h2>Portfolio Website</h2>
                    </a>
                    <a href="https://shubhamy.netlify.app/" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Built a fully responsive website for my portfolio.</p>
                </div>
                <div className="project">
                    <a href="https://github.com/shubhamy4ever/Meta-News-React" target="_blank" rel="noreferrer">
                        <img src={MetaNewsImage} className="zoom" alt="Meta News Thumbnail" width="100%" />
                        <h2>Meta News</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/Meta-News-React" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>A React-based news aggregation platform providing curated and trending articles.</p>
                </div>
                <div className="project">
                    <a href="https://github.com/shubhamy4ever/Online_Vaccination" target="_blank" rel="noreferrer">
                        <img src={OnlineVaccineImage} className="zoom" alt="Online Vaccination Thumbnail" width="100%" />
                        <h2>Online Vaccination Portal</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/Online_Vaccination" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Designed and built a vaccination appointment scheduling system with secure user authentication.</p>
                </div>

                <div className="project">
                    <a href="https://shubhamy4ever.github.io/Food_delivery/" target="_blank" rel="noreferrer">
                        <img src={FoodDeliveryImage} className="zoom" alt="Food Delivery App Thumbnail" width="100%" />
                        <h2>Food Delivery App</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/Food_delivery" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Developed a responsive food delivery application with live order tracking.</p>
                </div>
                <div className="project">
                    <a href="https://github.com/shubhamy4ever/cloud-notes-MERN" target="_blank" rel="noreferrer">
                        <img src={CloudNotesImage} className="zoom" alt="Cloud Notes Thumbnail" width="100%" />
                        <h2>Cloud Notes</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/cloud-notes-MERN" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Built a secure MERN stack-based note-taking app with cloud synchronization.</p>
                </div>
                <div className="project">
                    <a href="https://text-utility-with-react.vercel.app/" target="_blank" rel="noreferrer">
                        <img src={TextUtilityImage} className="zoom" alt="Text Utility Thumbnail" width="100%" />
                        <h2>Text Utility</h2>
                    </a>

                    <a href="https://github.com/shubhamy4ever/text-utility-with-react" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Created a text processing tool with React, offering various text transformation utilities.</p>
                </div>
                <div className="project">
                    <a href="https://github.com/shubhamy4ever/abhinav_college" target="_blank" rel="noreferrer">
                        <img src={AbhinavCollegeImage} className="zoom" alt="Abhinav College Website Thumbnail" width="100%" />
                        <h2>Abhinav College Website</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/abhinav_college" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Redesigned and developed the official website for Abhinav College with modern web technologies.</p>
                </div>
                <div className="project">
                    <a href="https://github.com/shubhamy4ever/Gym_website" target="_blank" rel="noreferrer">
                        <img src={GymImage} className="zoom" alt="Gym Website Thumbnail" width="100%" />
                        <h2>Gym Website</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/Gym_website" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Built a fully responsive website for a fitness center, landing page.</p>
                </div>
                <div className="project">
                    <a href="https://shubhamy4ever.github.io/js_calcy/" target="_blank" rel="noreferrer">
                        <img src={JsCalcyImage} className="zoom" alt="JS Calcy Thumbnail" width="100%" />
                        <h2>JS Calcy</h2>
                    </a>
                    <a href="https://github.com/shubhamy4ever/js_calcy" target="_blank" rel="noreferrer">
                        <p>GitHub Repository</p>
                    </a>
                    <p>Developed a lightweight calculator app using JavaScript for basic mathematical operations.</p>
                </div>
            </div>
        </div>
    );
}

export default Project;
